export default __webpack_public_path__ + "static/media/streamer_avatar1.0588a775.png";